export default (axios, key) => axios.get(`/restore/${key}`);
